import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { Link } from 'react-router-dom';
import useRoute from '../../hooks/routesHook';
import { EllipsisVerticalIcon } from '@heroicons/react/24/solid';

export interface ITabNavItem {
  id: any;
  title: string;
  activeTab: string | null;
  setActiveTab: (id: string) => void;
  onTabClicked?: (id: string) => void;
  classes?: string;
  icon?: JSX.Element;
  count?: number;
  page?: string;
  isPayoutTab?: boolean;
  actions?: JSX.Element;
}

const TabNavItem: React.FC<ITabNavItem> = ({
  id,
  title,
  activeTab,
  setActiveTab,
  classes,
  onTabClicked,
  icon,
  count,
  page,
  isPayoutTab,
  actions
}) => {
  const itemCount = count;
  const { getDashboardBase } = useRoute();

  const handleClick = () => {
    setActiveTab(id);
    onTabClicked?.(id);
  };

  const tabItem = () => {
    return (
      <div
        className={`px-5 py-3 flex gap-3 items-center text-sm font-medium rounded-t-lg transition-all duration-200 ${
          activeTab === id
            ? 'text-black dark:text-darkBg-mainText border-b-2 border-primary-main bg-blue-50 dark:bg-transparent'
            : 'text-gray-600  hover:bg-gray-50'
        }`}>
          
        {icon}
        <span className={icon && `hidden md:flex`}>{title}</span>
        {itemCount != null && (
          <div className="size-8 rounded-full p-2 bg-primary-surface dark:bg-darkBg-border flex items-center justify-center text-xs">
            {itemCount}
          </div>
        )}
        {actions}
      </div>
    );
  };

  return (
    <li
      onClick={!page ? handleClick : () => {}}
      className={clsx(
        'cursor-pointer font-medium w-fit list-none whitespace-nowrap text-sm flex items-center',
        classes
      )}>
      {page ? <Link to={`${getDashboardBase()}/${page}?${isPayoutTab ? `payoutTab=${id}` : `tab=${id}`}`}> {tabItem()} </Link> : tabItem()}
    </li>
  );
};

export default TabNavItem;
